import React from "react";
import { LedgerRecord } from "../../../services/interface";
import { useNavigate } from "react-router-dom";

interface Props {
  results: LedgerRecord[];
  onClose: () => void;
}

const LedgerSearchDropdown: React.FC<Props> = ({ results, onClose }) => {
  const navigate = useNavigate();

  if (results.length === 0) {
    return <p className="p-2">No data available</p>;
  }

  return (
    <div className="w-[21.7vw] mt-5 overflow-y-auto h-[150px]" id="ledger-header-table">
      {results.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            navigate(`/v1/ledger/${item.customer_id}`);
            onClose();
          }}
          className="inside_element"
        >
          <p className="w-[150px] cursor-pointer p-[5px]" id="ledger-header-table-name">
            {item.customer_name}
          </p>
          <p className="w-[130px] cursor-pointer p-[5px]" id="ledger-header-table-phn">
            {item.customer_phone_number}
          </p>
        </div>
      ))}
    </div>
  );
};

export default LedgerSearchDropdown;
